export const CLIENT_VERSION_STORAGE_KEY = 'minhub-app-version'
export const LAST_SEEN_CHANGELOG_STORAGE_KEY = 'minhub-last-seen-changelog'

export function isNewerDeployVersion(
	serverVersion: number,
	clientVersion: number | null,
): boolean {
	if (clientVersion === null) return false
	return serverVersion > clientVersion
}

export function hasUnreadChangelog(
	latestId: string | null | undefined,
	lastSeenId: string | null | undefined,
): boolean {
	if (!latestId) return false
	return latestId !== lastSeenId
}

export function buildHardReloadUrl(href: string, now: number): string {
	const url = new URL(href)
	url.searchParams.set('_r', String(now))
	return url.toString()
}

export function hardReloadApp(href = window.location.href, now = Date.now()) {
	window.location.replace(buildHardReloadUrl(href, now))
}
